// Hook do pobierania danych finansowych klienta

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IFinancialDataResponse {
  credit_limit: string;
  remaining: string;
  payment_due: string;
  receivables_overdue: string;
  is_blocked: boolean
}

const getFinancialData = (clientId: number): Promise<IFinancialDataResponse> =>
  axios.get('/financial', { params: { client_id: clientId } }); //todo adjust endpoint after be ready

export const useGetFinancialData = (
  clientId: number,
  options?: UseQueryOptions<IFinancialDataResponse, IError>
) =>
  useQuery<IFinancialDataResponse, IError>(
    ['financialData', clientId],
    () => getFinancialData(clientId),
    { enabled: clientId > 0, ...options }
  );
